// @module Convergence.TopDealsExt.TopDealsExt
define('Convergence.TopDealsExt.TopDealsExt.View'
,	[
	'convergence_topdealsext_topdealsext.tpl'
	
	,	"Convergence.TopDealsExty.TopDealsExt.Collection"
	
	,	'Backbone'
	,	'AjaxRequestsKiller'
	,	'Backbone.CollectionView'
	, 	'Utils'
	,	'Convergence.TopDealsExt.TopDealsExt.ItemCell.View'
	,	'facets_items_collection_view_cell.tpl'
	,	'facets_items_collection_view_row.tpl'
	,	'Configuration'

    ]
, function (
	convergence_topdealsext_topdealsext_tpl
	
	,	TopDealsExtCollection
	
	,	Backbone
	,	AjaxRequestsKiller
	,	BackboneCollectionView
	, 	Utils
	,	TopDealsExtItemCellView
	,	facets_items_collection_view_cell_tpl
	,	facets_items_collection_view_row_tpl
	,	Configuration
	
)
{
    'use strict';

	// @class Convergence.TopDealsExt.TopDealsExt.View @extends Backbone.View
	return Backbone.View.extend({

		template: convergence_topdealsext_topdealsext_tpl

	,	initialize: function (options) {
	
			this.application = options.container.getLayout().application;
			var self =this;
			this.collection = new TopDealsExtCollection();
			this.listenCollection();
			this.collection.on('reset', this.render, this);
			this.collection.fetch({
				killerId: AjaxRequestsKiller.getKillerId(),
			
			}).done(function () {
				self.render();
			}).fail(function (jqXhr, textStatus) {
				console.error('Error fetching collection:', textStatus);
				self.setLoading(false);
			})
		}
	
	,	render: function render() {
			this._render();
		
			var self = this;
			setTimeout(function () {
				self.initSlider();
			}, 0);
		}

	,	initSlider: function initSlider() {
			
			this.$slider = Utils.initBxSlider(this.$('[data-slider-new]'), {
				maxSlides: this.itemsPerRow || (Utils.isDesktopDevice() ? 3 : Utils.isTabletDevice() ? 2 : 1),
				minSlides: 1,
				pager: false,
				controls:false,
				startSlide: 0,
                touchEnabled: true,
			});
			this.$('[data-action="next-slide"]').off();
            this.$('[data-action="prev-slide"]').off();
			this.$('[data-action="next-slide"]').click(_.bind(this.nextImageEventHandler, this));
            this.$('[data-action="prev-slide"]').click(
                _.bind(this.previousImageEventHandler, this)
            );
		}

	,	previousImageEventHandler: function previousImageEventHandler() {
			this.$slider.goToPrevSlide();
		}

	,	nextImageEventHandler: function nextImageEventHandler() {
			this.$slider.goToNextSlide();
		}

	,	listenCollection: function () {
			this.setLoading(true);
			
			this.collection.on({
				request: jQuery.proxy(this, 'setLoading', true),
				reset: jQuery.proxy(this, 'setLoading', false)
			});
		}

	,	setLoading: function (is_loading) {
			this.isLoading = is_loading;
		}

	,	events: {

		}

	,	bindings: {
		}

	, 	childViews: {

			'TopDeals.Slide': function () {
				return new BackboneCollectionView({
					collection: this.collection,
					viewsPerRow:
						this.itemsPerRow ||
						(Utils.isDesktopDevice() ? 3 : Utils.isTabletDevice() ? 2 : 1),
					childView: TopDealsExtItemCellView,
					childViewOptions: {
						application: this.application,

					},
					
				});
			}
		}

		//@method getContext @return Convergence.TopDealsExt.TopDealsExt.View.Context
	,	getContext: function getContext()
		{
			
			//@class Convergence.TopDealsExt.TopDealsExt.View.Context

			var ConfData = Configuration.get('TopDealsExt');
			// console.log(ConfData);
			
			
			return {
				models: this.collection.models || [],
				ConfData:ConfData
			};
		}
	});
});
